export const SINGLE_CONTINUOUS = 1;
export const SINGLE_PER_PAGE = 2;
export const DOUBLE_CONTINUOUS = 3;
export const DOUBLE_PER_PAGE = 4;
